import { useMemo } from "react";
import { strCode } from "../../../consts";
import { FlexContainers, Heading5, IconButton, SVG, WrapperContainer } from "../../../components";
import { Fragment } from "react";
import { t } from "../../../services";
import PropTypes from "prop-types";

const LICENSES_DEFINITION_URLS = {
  MIT: strCode.MIT_URL,
  "Apache-2.0": strCode.APACHE_2_0_URL,
  "Apache 2.0": strCode.APACHE_2_0_URL,
  "CC0-1.0": strCode.CC0_1_0_URL,
  "BSD-3-Clause": strCode.BSD_3_Clause_URL,
  ISC: strCode.ISC_URL,
  "BSD-2-Clause": strCode.BSD_2_Clause_URL,
  "MPL-2.0": strCode.MPL_2_0_URL,
  "CC-BY-4.0": strCode.CC_BY_4_0_URL,
  BSD: strCode.BSD_URL,
  "0BSD": strCode._0BSD_URL,
  "GPL-2.0": strCode.GPL_2_0_URL,
  "EPL-1.0": strCode.EPL_1_0_URL,
  Zlib: strCode.Zlib_URL,
  WTFPL: strCode.WTFPL_URL,
  "CC-BY-3.0": strCode.CC_BY_3_0_URL,
  "MPL-1.1": strCode.MPL_1_1_URL,
  "Python-2.0": strCode.PYTHON_2_0_URL,
  "GPL-3.0": strCode.GPL_3_0_URL,
  "GPL-3.0-or-later": strCode.GPL_3_0_URL
};

export const LicenseHeader = ({ heading }) => {
  const licenses = useMemo(() => {
    const regex = /(\(|\)|AND|OR)/g;
    return heading
      .split(regex)
      .map((t) => t.trim())
      .filter((t) => t);
  }, [heading]);

  return (
    <Heading5>
      <WrapperContainer Container={FlexContainers.FlexRowStart}>
        {licenses.map((license, id) => {
          const definition = LICENSES_DEFINITION_URLS[license.replace(/[()*]/g, "")];
          return (
            <Fragment key={id}>
              {license + " "}
              {definition && (
                <WrapperContainer p={8}>
                  <IconButton
                    onClick={() => {
                      window.open(t(definition), "_blank", "noopener noreferrer");
                    }}
                    tooltipLabel={t(definition)}>
                    <SVG.NavigateToAppLinkIcon />
                  </IconButton>
                </WrapperContainer>
              )}
            </Fragment>
          );
        })}
      </WrapperContainer>
    </Heading5>
  );
};

LicenseHeader.propTypes = {
  heading: PropTypes.string.isRequired
};
